import { Tabs, TabsHeader, Tab } from "@material-tailwind/react";

import { HomeIcon, Cog6ToothIcon } from "@heroicons/react/24/solid";
import React from "react";
import { TopBarEngine } from "../Javascript_topbar/engine.js";
import { Settings } from "./Settings.js";
import { App } from "./App.js";
import ReactDOM from "react-dom/client";
import Profile_sending from "./Axios.js";
import StorageBox from "Store/StorageBox.js";
import Main from "./WidgetMain/Main.tsx";

// Global fallbacks used across class methods and render
const ORANGE_FALLBACK_BG =
  "data:image/svg+xml;utf8,\n<svg xmlns='http://www.w3.org/2000/svg' width='1920' height='1080' viewBox='0 0 1920 1080'>\n  <defs>\n    <linearGradient id='bgGrad' x1='0' y1='0' x2='1' y2='1'>\n      <stop offset='0%' stop-color='%23DE741C'/>\n      <stop offset='100%' stop-color='%23FF9A3D'/>\n    </linearGradient>\n    <radialGradient id='glow' cx='0.75' cy='0.25' r='0.8'>\n      <stop offset='0%' stop-color='white' stop-opacity='0.25'/>\n      <stop offset='100%' stop-color='white' stop-opacity='0'/>\n    </radialGradient>\n    <pattern id='stripes' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='rotate(30)'>\n      <rect width='40' height='40' fill='none'/>\n      <rect width='20' height='40' fill='white' opacity='0.04'/>\n    </pattern>\n  </defs>\n  <rect width='100%' height='100%' fill='url(%23bgGrad)'/>\n  <rect width='100%' height='100%' fill='url(%23stripes)'/>\n  <circle cx='1536' cy='270' r='500' fill='url(%23glow)'/>\n</svg>";

const ORANGE_FALLBACK_AVATAR =
  "data:image/svg+xml;utf8,\n<svg xmlns='http://www.w3.org/2000/svg' width='256' height='256' viewBox='0 0 256 256'>\n  <defs>\n    <radialGradient id='r' cx='0.35' cy='0.35' r='0.9'>\n      <stop offset='0%' stop-color='%23FFA559'/>\n      <stop offset='100%' stop-color='%23DE741C'/>\n    </radialGradient>\n    <linearGradient id='ring' x1='0' y1='0' x2='1' y2='1'>\n      <stop offset='0%' stop-color='white' stop-opacity='0.65'/>\n      <stop offset='100%' stop-color='white' stop-opacity='0.05'/>\n    </linearGradient>\n    <pattern id='p' patternUnits='userSpaceOnUse' width='16' height='16' patternTransform='rotate(35)'>\n      <rect width='16' height='16' fill='none'/>\n      <rect width='8' height='16' fill='white' opacity='0.06'/>\n    </pattern>\n  </defs>\n  <rect width='256' height='256' rx='128' fill='url(%23r)'/>\n  <rect width='256' height='256' rx='128' fill='url(%23p)'/>\n  <circle cx='128' cy='128' r='120' fill='none' stroke='url(%23ring)' stroke-width='4'/>\n  <ellipse cx='92' cy='84' rx='40' ry='22' fill='white' opacity='0.12'/>\n</svg>";

class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      count: 0,
      isAllowed: false,
      isNavbarVisible: false,
      imageUrl:
        "https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80",
      isError: false,
      user: {},
      isFinishLoading: false,
      UserName: null,
      isPersonalUser: false,
      userData: null, // Store user data for viewing other profiles
    };
  }

  componentDidMount() {
    const load = async () => {
      const App1 = await import("../Javascript_topbar/engine.js");
    };
    load();
    this.initializer();
    //to check if you are the user or not
    this.authentication();
  }

  authentication() {
    const url = new URL(window.location.href);

    // Get the value of the 'profile' query parameter
    const profileValue = url.searchParams.get("profile");
    console.log(profileValue);

    /*
    if (profileValue == "true" && sessionStorage.getItem("i_email") != null) {
      var Json = {
        userEmail: sessionStorage.getItem("i_email"),
        authToken: sessionStorage.getItem("i_authToken"),
      };
      Profile_sending.personal_profile_taker(Json).then((res) => {
        if (res.status == 200) {
          console.log("check2232" + res.data);
          this.setState({ isAllowed: true });
        } else {
          this.setState({ isAllowed: false });
        }
      });
    }*/
    /* if (UserChecker.IsLoggedIn() == true) {
      this.setState({ isAllowed: true });
    } else {
      this.setState({ isAllowed: false });
    }*/
  }

  async initializer() {
    const url = new URL(window.location.href);

    // Get the value of the 'profile' query parameter and decode it
    const profileValue = url.searchParams.get("user");
    const decodedProfileValue = profileValue
      ? decodeURIComponent(profileValue)
      : null;
    console.log(profileValue);
    console.log("Decoded:", decodedProfileValue);

    // Get current logged-in admin user
    const currentAdminUser = StorageBox.getUserName();

    if (decodedProfileValue != null) {
      var Json = {
        userName: decodedProfileValue,
      };
      this.setState({ isAllowed: false });
      // Check if viewing own profile or someone else's
      const isViewingOwnProfile = decodedProfileValue === currentAdminUser;
      Profile_sending.profile_taker(Json).then(async (res) => {
        // Store user data in state for App.js to use
        this.setState({ userData: res[0] });
        // Only update StorageBox if viewing own profile
        await this.working_engine(res[0], isViewingOwnProfile);
        console.log("whatt");
        this.backgroundImage_engine();
      });
    } else {
      var item = StorageBox.getProfileUserName();
      console.log(item);
      console.log("what is here" + item);
      this.setState({ user: item });
      var Json = {
        userName: item,
      };
      this.setState({ isAllowed: true });
      Profile_sending.profile_taker(Json).then(async (res) => {
        // Store user data in state for App.js to use
        this.setState({ userData: res[0] });
        // Always update StorageBox when viewing own profile (no user param)
        await this.working_engine(res[0], true);
        console.log("whatt");
        this.backgroundImage_engine();
      });
    }
  }

  incrementCount() {
    this.setState((prevState) => ({
      count: prevState.count + 1,
    }));
  }

  working_engine(res, shouldUpdateStorage = true) {
    return new Promise((resolve) => {
      // Only update StorageBox if viewing own profile
      if (shouldUpdateStorage) {
        StorageBox.inputUserDataStorageId(res);
        StorageBox.inputUserDetails(res);
      }
      this.setState({ isFinishLoading: true });
      console.log("what is here");
      console.log(res);
      this.setState({ UserName: res.UserName.trim() }, resolve);
    });
  }

  backgroundImage_engine() {
    const url = new URL(window.location.href);

    // Get the value of the 'profile' query parameter
    const profileValue = url.searchParams.get("user");

    var profilePicUrl;
    var backgroundUrl;
    //if (profileValue != null || sessionStorage.getItem("i_name") != null) {
    //  if(sessionStorage.getItem("i_name") != null){

    /* profilePicUrl = `https://tanyapendeta.today/images/profile/${sessionStorage
        .getItem("i_firstname")
        .split(" ")
        .join("")}.jpg?${Date.now()}`;
      backgroundUrl = `https://tanyapendeta.today/images/profile/${sessionStorage
        .getItem("i_firstname")
        .split(" ")
        .join("")}background.jpg?${Date.now()}`;*/
    console.log("whyyyyyy");
    console.log(this.state.UserName);
    if (this.state.UserName != null) {
      const randomNum = Math.floor(Math.random() * 1000);
      const timestamp = Date.now();
      profilePicUrl = `https://kbuzjqfgjvrgbivzbxjb.supabase.co/storage/v1/object/public/tanyapendeta%20bucket/profile_${this.state.UserName}?_${randomNum}_${timestamp}`;

      backgroundUrl =
        "https://kbuzjqfgjvrgbivzbxjb.supabase.co/storage/v1/object/public/tanyapendeta%20bucket/background_" +
        this.state.UserName +
        "?_" +
        randomNum +
        "_" +
        timestamp;

      const imgProfile = new Image();
      imgProfile.src = profilePicUrl;
      imgProfile.onerror = function () {
        // This code will run if the profile image fails to load
        console.log("Profile image failed to load.");
        console.log(profilePicUrl);
        var el = document.getElementById("profile_pic");
        if (el) {
          el.src = ORANGE_FALLBACK_AVATAR;
        }
      };
      imgProfile.onload = function () {
        // This code will run if the profile image loads successfully
        console.log("Profile image loaded successfully.");
        var el = document.getElementById("profile_pic");
        if (el) {
          el.src = profilePicUrl;
        }
      };

      const img = new Image();
      img.src = backgroundUrl;
      img.onerror = function () {
        console.log("Profile image failed to load.");
        backgroundUrl =
          "https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80";
        var elBg = document.getElementById("i_background_profile");
        if (elBg) {
          elBg.src = backgroundUrl;
        }
      };

      // Optionally, you can also handle the onload event to know when the image has successfully loaded
      img.onload = function () {
        console.log("Image loaded successfully.");
        var elBg = document.getElementById("i_background_profile");
        if (elBg) {
          elBg.src = backgroundUrl;
        }
      };
    }
  }

  Settings() {
    document.getElementById("profile_displayer").innerHTML = "";
    var v = document.createElement("div");
    v.id = "Right_02_02";
    document.getElementById("profile_displayer").appendChild(v);
    var container = React.createElement(Settings, {}, null);
    const root = ReactDOM.createRoot(v);
    root.render(container);
  }

  App() {
    document.getElementById("profile_displayer").innerHTML = "";
    var v = document.createElement("div");
    v.id = "Right_02_02";
    document.getElementById("profile_displayer").appendChild(v);
    // Pass userData as prop to App component
    var container = React.createElement(
      App,
      { userData: this.state.userData },
      null
    );
    const root = ReactDOM.createRoot(v);
    root.render(container);
  }

  toggleNavbar = () => {
    console.log("apa nini");
    this.setState({ isNavbarVisible: !this.state.isNavbarVisible });
  };

  handleImageError = () => {
    this.setState({
      imageUrl:
        "https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80",
      isError: true,
    });
  };

  render() {
    const { imageUrl, isError } = this.state;

    // Orange-themed inline SVG fallbacks (no network dependency)

    const backgroundStyle = {
      backgroundImage: `url(${imageUrl || ORANGE_FALLBACK_BG})`,
    };
    const { isNavbarVisible } = this.state;
    return (
      <div className="mt-[5%] inline-grid h-full w-[95%] flex-col">
        <div
          className="main_container mt-30 justify-center"
          id="main_container"
        >
          <div className="profile float-right w-[95%]">
            <div className="relative mt-8 h-72 w-full overflow-hidden rounded-xl bg-cover bg-center">
              <img
                alt="Good Background"
                id="i_background_profile"
                src={imageUrl || ORANGE_FALLBACK_BG}
                onError={(e) => {
                  if (
                    e.currentTarget &&
                    e.currentTarget.src !== ORANGE_FALLBACK_BG
                  ) {
                    e.currentTarget.src = ORANGE_FALLBACK_BG;
                    this.setState({ isError: true });
                  }
                }}
                className={`h-full w-full overflow-hidden rounded-xl bg-cover bg-center object-cover`}
              />
            </div>
            <div className="relative mx-3 -mt-16 mb-6 flex flex-col rounded-xl bg-white bg-clip-border text-gray-700 shadow-md lg:mx-4">
              <div className="p-4">
                <div className="mb-10 flex items-center justify-between gap-6">
                  <div className="flex items-center gap-6">
                    <img
                      alt="profile"
                      src={ORANGE_FALLBACK_AVATAR}
                      onError={(e) => {
                        if (e.currentTarget) {
                          e.currentTarget.src = ORANGE_FALLBACK_AVATAR;
                        }
                      }}
                      className="shadow-blue-gray-500/40 relative inline-block h-[74px] w-[74px] !rounded-full rounded-lg object-cover object-center shadow-lg"
                      id="profile_pic"
                    />
                    <div>
                      <h5
                        className="text-blue-gray-900 mb-1 block font-sans text-xl font-semibold leading-snug tracking-normal antialiased"
                        id="Username"
                      >
                        Richard Davis
                      </h5>
                      <p
                        className="text-blue-gray-600 block font-sans text-sm font-normal leading-normal antialiased"
                        id="user_paragraph"
                      >
                        CEO / Co-Founder
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="inline-flex h-full items-center justify-center rounded-r-md border-l border-gray-100 px-2 text-gray-600 hover:bg-gray-50 hover:text-gray-700 md:hidden"
                    onClick={this.toggleNavbar}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="h-6 w-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                      />
                    </svg>
                  </button>

                  <div
                    className={`absolute left-0 top-[-50px] w-[100%] md:static md:block md:w-[50%] ${
                      isNavbarVisible ? "block" : "hidden"
                    }`}
                  >
                    <Tabs value="app">
                      <TabsHeader>
                        <Tab value="app" onClick={this.App}>
                          <HomeIcon className="-mt-1 mr-2 inline-block h-5 w-5" />
                          Home
                        </Tab>

                        {this.state.isAllowed && (
                          <Tab value="settings" onClick={this.Settings}>
                            <Cog6ToothIcon className="-mt-1 mr-2 inline-block h-5 w-5" />
                            Settings
                          </Tab>
                        )}
                      </TabsHeader>
                    </Tabs>
                  </div>
                </div>
                {this.state.isFinishLoading ? (
                  <div id="profile_displayer">
                    <App userData={this.state.userData} />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div
          className="min-h-full w-max place-content-center place-self-center pb-20 pt-5 md:mx-64"
          style={{
            textAlign: "-webkit-center",
            width: "-webkit-fill-available",
          }}
        ></div>
      </div>
    );
  }
}

export default Profile;
